(function () {
  const grid = document.getElementById('product-grid');
  const paginationWrapper = document.querySelector('.pagination-wrapper');

  if (!grid) return;

  function getNextUrl(doc) {
    const allLinks = doc.querySelectorAll('.pagination__item-arrow');
    if (!allLinks.length) return null;
    const last = allLinks[allLinks.length - 1];
    return last.classList.contains('pagination__item--next') ? null : last.href;
  }

  let nextUrl = getNextUrl(document);
  console.log('✅ Start nextUrl:', nextUrl);

  if (!nextUrl) return;

  if (paginationWrapper) paginationWrapper.style.display = 'none';

  // Spinner — grid ke baad
  const spinner = document.createElement('div');
  spinner.style.cssText = 'display:none;text-align:center;padding:2rem;';
  spinner.innerHTML = `
    <style>@keyframes is-spin{to{transform:rotate(360deg)}}</style>
    <div style="width:36px;height:36px;border:3px solid #ccc;border-top-color:#333;
      border-radius:50%;animation:is-spin .7s linear infinite;display:inline-block;"></div>
  `;
  grid.after(spinner);

  // Sentinel — bilkul page ke end mein
  const sentinel = document.createElement('div');
  sentinel.style.cssText = 'height:10px;width:100%;display:block;';
  document.body.appendChild(sentinel);

  let loading = false;

  const observer = new IntersectionObserver(async (entries) => {
    if (!entries[0].isIntersecting || loading || !nextUrl) return;

    loading = true;
    spinner.style.display = 'block';

    try {
      console.log('🔄 Fetching:', nextUrl);
      const res = await fetch(nextUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('#product-grid .grid__item');
      console.log('📦 Items mile:', newItems.length);
      newItems.forEach(item => grid.appendChild(item));

      nextUrl = getNextUrl(doc);
      console.log('➡️ Next URL now:', nextUrl);

      if (!nextUrl) {
        console.log('🏁 Last page!');
        observer.disconnect();
        sentinel.remove();
      }

    } catch (err) {
      console.error('❌ Error:', err);
    }

    spinner.style.display = 'none';
    loading = false;

  }, { 
    root: null,        // viewport
    rootMargin: '400px', // bilkul viewport edge pe trigger
    threshold: 0.1 
  });

  observer.observe(sentinel);

})();